import { FC } from 'react';
import { Section } from './ui/Section';
import { EntryBlock } from './ui/EntryBlock';
import type { Entry } from '../types/cv';

interface Props {
  volunteer: Entry[];
  title?: string;
}

export const Volunteer: FC<Props> = ({ volunteer, title = 'Volunteer' }) => (
  <Section title={title}>
    {volunteer.map((item, i) => (
      <EntryBlock
        key={`${item.organization}-${i}`}
        entry={item}
        title={item.organization ?? item.name}
        role={item.position}
        note={item.summary}
      />
    ))}
  </Section>
);

export default Volunteer;
